import http from '@/http-common';
import fnc from '@/fnc';

export default {
    namespaced:true,
    state: {
        webData         : null,
        lastTicketViews : localStorage.getItem('lastViews') ? JSON.parse(fnc.base64decode(localStorage.getItem('lastViews'))) : [],
    },
    actions:{
         getWebData({commit}){
            return http.post('api/webData',{}).then(res => {
                if(res.success){
                    commit('SET_WEB_DATA',res.response);
                }
                return Promise.resolve(res);
            });
        },
        addLastTicketView({state},ticket){
            let Index = fnc.findIndexByIdx(ticket.ticketIdx,state.lastTicketViews,"ticketIdx");
            if(Index === -1){
             state.lastTicketViews.push({
                 ticketIdx  : ticket.ticketIdx,
                 title      : ticket.title,
                 datetime   : Date.now()
             });
            }else{
             state.lastTicketViews[Index].datetime = Date.now();
            }
            state.lastTicketViews = state.lastTicketViews.sort((a, b) => b.datetime - a.datetime);
            if(state.lastTicketViews.length > 10){
                delete state.lastTicketViews.splice(-1);
            }
            localStorage.setItem('lastViews',fnc.base64encode(JSON.stringify(state.lastTicketViews)));
        }

    },
    mutations:{
        SET_WEB_DATA(state,webData){
            state.webData         = webData;
        },
    },
    getters:{
        webData           : (state) => state.webData,
        lastTicketViews   : (state) => state.lastTicketViews,
    }


}